<template>
	<div class="shopCar px16 layui-layout layui-layout-admin" style="background:#fff;overflow-y:auto;max-height:100%;">
		<div class="layui-header al_itm" style="background:#fff;">
			<div class="px18 al_itm" style="color:#000;margin-left:20px;">
				<i @click="back" class="layui-icon-left layui-icon px20 pointer" style="margin-right:20px;"></i>订单详情
			</div>
		</div>
		<div>
			<div class="f_col px16" style="padding:20px 30px;line-height: 50px;">
				<p>订单编号 <span>{{order_info.order_num}}</span> </p>
				<p>订单状态 <span>{{order_info.status_text}}</span> </p>
				<p>交付类型 <span class="mon_color">{{order_info.is_fast_text}}</span> </p>
				<p v-if="order_info.status == 6 || order_info.status == 4">发货倒计时 <span class="mon_color">{{times}}</span><span v-if="order_info.status == 4" @click="fAppealOrder()" class="btn1">材料不足申请</span></p>
				<p v-if="finish_time && order_info.status != 1 && order_info.status != 15 && timeline.f_finish_order_time">到货时间 <span class="mon_color"> 预计{{finish_time}}到货</span></p>
				<p v-if="express_id.id == 12 || express_id.id == 13">
					<p>发货方式 <span class="mon_color">{{express_id.company}}</span> </p>
				</p>
			</div>
			<div v-if="orderprogress1">
				<div class="zt_color title" style="padding:8px 30px;color:#fff;">订单进度</div>
				<ul class="layui-timeline" style="padding:20px 30px;">
					<li class="layui-timeline-item" v-for="(item,i) in order_progress">
						<i class="layui-icon layui-timeline-axis zt_txt_color px20">&#xe617;</i>
						<div class="layui-timeline-content layui-text">
							<div class="layui-timeline-title" style="display: flex;">
								<div class="px16">{{item.title}}</div>
								<div class="px14 margin_l10">{{item.time_txt}}</div>
								<div v-if='i == 3 && order_info.status == 6 && orderprogress1.is_after_sales == 0' @click="finishOrder(1)" class="btn1">{{express_id.id == 12 || express_id.id == 13?'出货':'发货'}}</div>
								<span v-if="i == 3 && order_info.status == 6 && orderprogress1.is_after_sales == 0" @click="onLayer" class="px12 margin_l10" style="color: #4876FF;">【说明】</span>
								<div class="px14 margin_l10" v-if="i == 4 && timeline.f_finish_order_time && express_id.id != 12 && express_id.id != 13">{{express_info.express_name}} <span>{{express_info.express_mailno}}</span></div>
								<div v-if="i == 4 && timeline.f_finish_order_time && express_id.id != 12 && express_id.id != 13" class="btn1" @click="onLogistics(1)">物流信息</div>
								<div v-if='i == 4 && order_info.status == 7 && orderprogress1.is_f_rep_order == 0 && orderprogress1.is_after_sales == 0 && express_id.id != 12 && express_id.id != 13' @click="finishOrder(2)" class="btn1">补发快递</div>
								<div v-if="i == 5 && timeline.f_rep_order_time && express_id.id != 12 && express_id.id != 13" class="btn1" @click="onLogistics(2)">物流信息</div>
								<div class="px14 margin_l10" v-if="i == 5 && timeline.f_get_order_time && express_id.id != 12 && express_id.id != 13">{{express_info.rep_express_name}} <span>{{express_info.rep_express_mailno}}</span></div>
								<div v-if="item.title == '工厂重新发货'&& timeline.f_rework_finish_time== null" @click="finishOrder(3)" class="btn1">{{express_id.id == 12 || express_id.id == 13?'出货':'发货'}}</div>
								<div class="px14 margin_l10" v-if="item.title == '工厂重新发货'&& timeline.f_rework_finish_time && express_id.id != 12 && express_id.id != 13">{{express_info.sale_express_name}}
									<span>{{express_info.sale_express_mailno}}</span></div>
								<div v-if="item.title == '工厂重新发货'&& timeline.f_rework_finish_time && express_id.id != 12 && express_id.id != 13" class="btn1" @click="onLogistics(3)">物流信息</div>
							</div>
							<div style="height: 25px;"></div>
						</div>
					</li>
				</ul>
			</div>

			<div v-if='mesh_attr!=[] && mesh_attr[0]'>
				<div class="zt_color title" style="padding:8px 30px;color:#fff;">钢网规格</div>
				<table class="layui-table align_center orBoxs" lay-skin='' style="">
					<thead>
						<tr class="white">
							<th class="align_center">序号</th>
							<th class="align_center">钢片规格</th>
							<th class="align_center">钢片有效印刷面积</th>
							<th class="align_center">数量</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item,i) in mesh_attr" :key="i">
							<td>{{i+1}}</td>
							<td>{{item.attr_title}}</td>
							<td>{{item.use_title}}</td>
							<td>{{craft_demand[i].buy_num}}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div>
				<div class="zt_color title" style="padding:8px 30px;color:#fff;">工艺要求</div>
				<table class="layui-table align_center orBoxs" lay-skin='' style="">
					<thead>
						<tr class="white">
							<th class="align_center">序号</th>
							<th class="align_center">制作要求</th>
							<th class="align_center">交付类型</th>
							<th class="align_center">激光打标</th>
							<th class="align_center">钢网工艺</th>
							<th class="align_center">制作工艺</th>
							<th class="align_center">钢片厚度</th>
							<th class="align_center">Mark基准点</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item,i) in craft_demand" :key="i">
							<td>{{i+1}}</td>
							<td>{{item.make_demand_text}}</td>
							<td :class="item.is_fast_text=='加急件'?'colorred':''">{{item.is_fast_text}}</td>
							<td>{{item.laser_marking_text}}</td>
							<td>{{item.mesh_purpose_text}}</td>
							<td>{{item.mark_craft_text}}</td>
							<td>{{item.thick_num_text}}</td>
							<td>{{item.mark_point_text}}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div>
				<div class="zt_color title">CHIP开孔要求</div>
				<table class="layui-table align_center orBoxs">
					<colgroup>
						<col width="200">
						<col>
						<col>
						<col>
						<col>
					</colgroup>
					<thead>
						<tr class="white">
							<th class="align_center">序号</th>
							<th class="align_center">开孔工艺</th>
							<th class="align_center">开孔类型</th>
							<th class="align_center">开孔方案</th>
							<th class="align_center">防锡珠类型</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item,i) in open_demand" :key="i">
							<td>{{i+1}}</td>
							<td>{{item.mesh_type == 1 ? '锡膏工艺' : '红胶工艺'}}</td>
							<td>{{item.mesh_type == 2 ? '' : item.hole}}</td>
							<td class="align_center">{{item.solder_hole_size_text}}</td>
							<td>{{item.hole_type}}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div v-if="hideICBGAPAD">
				<div class="zt_color title">IC集成电路开孔要求</div>
				<table class="layui-table align_center orBoxs">
					<colgroup>
						<col width="200">
						<col>
						<col>
						<col>
					</colgroup>
					<thead>
						<tr class="white">
							<th class="align_center">序号</th>
							<th class="align_center">开孔方案</th>
							<th class="align_center">开孔宽度</th>
							<th class="align_center">开孔形状</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item,i) in craft_demand" :key="i" v-if="open_demand[i].mesh_type == 1">
							<td>{{i+1}}</td>
							<td>{{item.ic_open_ask_text}}</td>
							<td>{{item.ic_open_ask_size_text}}</td>
							<td>{{item.ic_open_shape_text}}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div v-if="hideICBGAPAD">
				<div class="zt_color title">BGA封装开孔要求</div>
				<table class="layui-table align_center orBoxs">
					<colgroup>
						<col width="200">
						<col>
						<col>
						<col>
					</colgroup>
					<thead>
						<tr class="white">
							<th class="align_center">序号</th>
							<th class="align_center">开孔方案</th>
							<th class="align_center">开孔直径</th>
							<th class="align_center">开孔形状</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item,i) in craft_demand" :key="i">
							<td>{{i+1}}</td>
							<td>{{item.bga_open_ask_text}}</td>
							<td>{{item.bga_open_ask_size_text}}</td>
							<td>{{item.bga_open_shape_text}}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div v-if="hideICBGAPAD">
				<div class="zt_color title">散热PAD(接地焊盘)</div>
				<table class="layui-table align_center orBoxs">
					<colgroup>
						<col width="200">
						<col>
						<col>
					</colgroup>
					<thead>
						<tr class="white">
							<th class="align_center">序号</th>
							<th class="align_center">开孔形状</th>
							<th class="align_center">开孔面积</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item,i) in craft_demand" :key="i">
							<td>{{i + 1}}</td>
							<td>{{item.pad_open_shape_text}}</td>
							<td>{{item.pad_open_area_text}}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div>
				<div class="zt_color title" style="padding:8px 30px;color:#fff;">其他制作要求和工程文件</div>
				<table class="layui-table align_center orBoxs" lay-skin='' style="">
					<thead>
						<tr class="white">
							<th class="align_center">序号</th>
							<th class="align_center">工程文件</th>
							<th class="align_center">其他要求说明</th>
							<th class="align_center">上传工程文件</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item,i) in other_make" :key="i">
							<td>{{i+1}}</td>
							<td class="d_line pointer zt_txt_color">
								<a :href="item.pdf_file" class="lines" v-if="item.pdf_file">工程文件</a>
								<a :href="item.pdf_file" class="downloadBtn" v-if="item.pdf_file">下载</a>
							</td>
							<td>{{item.message == undefined ? '无': item.message}}</td>
							<td class="d_line pointer zt_txt_color">
								<a :href="item.e_pdf_file" class="lines" v-if="">工程文件完成版</a>
								<a :href="item.e_pdf_file" class="downloadBtn" v-if="item.e_pdf_file">下载</a>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div>
				<div class="zt_color title" style="padding:8px 30px;color:#fff;">收货地址&订单联系人</div>
				<div class="layui-row">
					<div class="f_col px16 layui-col-md5" style="padding:20px 30px;">
						<span>{{take_info.take_name}}, {{take_info.take_mobile}}</span>
						<span style="margin: 20px 0;">{{take_info.take_address}}</span>
					</div>
				</div>
			</div>
			<div>
				<div class="zt_color title" style="padding:8px 30px;color:#fff;">快递信息</div>
				<table class="layui-table align_center orBoxs" lay-skin='' lay-size="lg" style="">
					<thead>
						<tr class="white">
							<th class="align_center">发货状态</th>
							<th class="align_center">快递公司</th>
							<th class="align_center">快递单号</th>
							<th class="align_center">配送费用(元)</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>订单发货</td>
							<td>{{express_info.express_name?express_info.express_name: '无'}}</td>
							<td>{{express_info.express_mailno?express_info.express_mailno: '无'}}</td>
							<td>{{express_info.express_money?express_info.express_money: '无'}}</td>
						</tr>
						<tr>
							<td>订单补发</td>
							<td>{{express_info.rep_express_name?express_info.rep_express_name: '无'}}</td>
							<td>{{express_info.rep_express_mailno?express_info.rep_express_mailno: '无'}}</td>
							<td>{{express_info.rep_express_money?express_info.rep_express_money: '无'}}</td>
						</tr>
						<tr>
							<td>订单售后补发</td>
							<td>{{express_info.sale_express_name?express_info.sale_express_name: '无'}}</td>
							<td>{{express_info.sale_express_mailno?express_info.sale_express_mailno: '无'}}</td>
							<td>{{express_info.sale_express_money?express_info.sale_express_money: '无'}}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<!-- 德邦发货信息 -->
		<div id="express" style="display: none;padding: 30px;">
			<form class="layui-form" action="">
				<div class="layui-form-item">
					<label class="layui-form-label">地址</label>
					<div class="layui-input-block" v-if="siteslist!=[]">
						<div class="color_h">
							<div class="px16">{{fname}} <span class="px12">{{fphone}}</span></div>
							<div class="px14 sitetext">{{fsite}}</div>
						</div>
						<span class="pointer" style="color:rgb(255, 152, 0);" @click="selectsite">选择</span>
					</div>
					<div class="layui-input-block" v-if="siteslist==[]" @click="addsites">选择</div>
				</div>
				<div class="layui-form-item" v-if="express_id.id != 11">
					<label class="layui-form-label">货物名称</label>
					<div class="layui-input-block">
						<input type="text" name="Hname" required lay-verify="required" placeholder="请输入货物名称" autocomplete="off" class="layui-input">
					</div>
				</div>
				<div class="layui-form-item" v-if="express_id.id != 3 && express_id.id != 11">
					<label class="layui-form-label">送货方式</label>
					<div class="layui-input-block">
						<select name="mode" lay-verify="required">
							<option value=""></option>
							<option value="0">自提</option>
							<option value="1">送货进仓</option>
							<option value="2">送货(不含上楼)</option>
							<option value="3">送货上楼</option>
							<option value="4">大件上楼</option>
						</select>
					</div>
				</div>
				<div class="layui-form-item" v-if="express_id.id == 3">
					<label class="layui-form-label">货物件数</label>
					<div class="layui-input-block">
						<input type="number" name="title4" required lay-verify="required" placeholder="请输入件数" autocomplete="off" class="layui-input">
					</div>
				</div>
				<div class="layui-form-item">
					<label class="layui-form-label">总件数(包裹数)</label>
					<div class="layui-input-block">
						<input type="number" name="title" required lay-verify="required" placeholder="请输入件数" autocomplete="off" class="layui-input">
					</div>
				</div>
				<div class="layui-form-item" v-if="express_id.id != 3">
					<label class="layui-form-label" v-if="express_id.id != 11">总体积(m³)</label>
					<label class="layui-form-label" v-if="express_id.id == 11">总体积(cm³)</label>
					<div class="layui-input-block">
						<input type="number" name="title2" required lay-verify="required" placeholder="请输入体积" autocomplete="off" class="layui-input">
					</div>
				</div>
				<div class="layui-form-item">
					<label class="layui-form-label">总重量(kg)</label>
					<div class="layui-input-block">
						<input type="number" name="title3" required lay-verify="required" placeholder="请输入重量" autocomplete="off" class="layui-input">
					</div>
				</div>
				<div class="layui-form-item" v-if="express_id.id != 3 && express_id.id != 11">
					<label class="layui-form-label">包装</label>
					<div class="layui-input-block">
						<select name="packing" lay-verify="required">
							<option value=""></option>
							<option value="0">纸</option>
							<option value="1">纤</option>
							<option value="2">木箱</option>
							<option value="3">木架</option>
							<option value="4">托膜</option>
							<option value="5">拖木(大客户模式下运输方式为零担时必填)</option>
						</select>
					</div>
				</div>
				<div class="layui-form-item" v-if="express_id.id == 3">
					<label class="layui-form-label">备注</label>
					<div class="layui-input-block">
						<textarea name="desc" placeholder="请输入内容" class="layui-textarea"></textarea>
					</div>
				</div>
				<div class="layui-form-item">
					<div class="layui-input-block">
						<button type="reset" class="layui-btn layui-btn-primary">重置</button>
					</div>
				</div>
			</form>
		</div>
		<!-- 工厂申请 -->
		<div id="applyer" style="display: none;padding: 30px;">
			<div style="margin-bottom: 10px;">申请信息</div>
			<textarea name="applyerText" v-model="applyerText" required lay-verify="required" placeholder="请输入申请信息" autocomplete="off" class="layui-textarea"></textarea>
		</div>
		<!-- 顺丰快递弹框 -->
		<div id="sflayer" style="display:none;padding:30rpx;margin: 30px;">
			<label class="layui-form-label">地址</label>
			<div class="layui-input-block" v-if="siteslist!=[]">
				<div class="color_h">
					<div class="px16">{{fname}} <span class="px12">{{fphone}}</span></div>
					<div class="px14 sitetext">{{fsite}}</div>
				</div>
				<span class="pointer" style="color:rgb(255, 152, 0);" @click="selectsite">选择</span>
			</div>
			<div class="layui-input-block addsites" v-if="siteslist==[]" @click="addsites">选择</div>
		</div>
		<!-- 地址选择 -->
		<div id="siteslists" style="display: none;padding: 30px;">
			<div v-for="(item,i) in siteslist" :key="i" style="display: flex;flex-wrap: nowrap;">
				<div>
					<div class="color_h">
						<div class="px16">{{item.name}} <span class="px12">{{item.mobile}}</span></div>
						<div class="px14 sitetext">{{item.province}}{{item.city}}{{item.area}}{{item.address}}</div>
					</div>
					<span style="color:#248aff;" class="px12 margin_b10" v-if="i == 0?true:false">默认</span>
				</div>
				<div class="px14 pointer" style="color:rgb(255, 152, 0);line-height: 40px;" @click="select(item,i)" v-if="i == 0?false:true">选择</div>
			</div>
		</div>
		<el-dialog title="物流信息" :visible.sync="wuliushow" :append-to-body='true'>
			<el-steps direction="vertical" :active="0" space="60px">
				<el-step v-for="(item,i) in wuliu" :key='i' :title="item.site" :description="item.description + ' ' + item.time" :status="i == 0 ? 'success' : 'wait'" icon='el-icon-circle-check'></el-step>
			</el-steps>
		</el-dialog>
	</div>
</template>

<script>
	import city from "@/utils/city.js";
	export default {
		name: 'shopCar',
		data() {
			return {
				dscModel: false,
				showClass: 1,
				finish_time: '', //预计到货时间
				order_info: [], // 订单详情
				mesh_attr: [], // 钢网规格
				craft_demand: [], // 工艺要求
				open_demand: [], // 开孔要求
				other_make: [], // 其他制作要求和工程文件
				take_info: [], // 收货地址&订单联系人
				express_info: [],
				express_id: [], //快递信息
				tables: '',
				formss: '',
				layer: '',
				order_progress: [],
				orderprogress1: '',
				times: '',
				areaData: '',
				province: 0,
				province2: 0,
				city: 0,
				city2: 0,
				area: 0,
				applyerText: '',
				siteslist: [],
				fname: '',
				fphone: '',
				fsite: '',
				statuss: '',
				wuliushow: false,
				wuliu: [], //物流轨迹
				hideICBGAPAD: true,
				submitshow: true,
				onLogisticsclick: true,
				timeline: ''
			}
		},
		created() {
			this.areaData = city.city;
			let order_num = this.$route.query.id;
			if(order_num) {
				this.getData(order_num);
			} else {
				this.$router.replace({
					path: '/shopCar'
				})
			}

		},
		mounted() {
			let _this = this
			layui.use(['table', 'form', 'layer'], () => {
				this.tables = layui.table;
				this.formss = layui.form;
				this.layers = layui.layer;
				this.formss.render();
				this.formss.on('select()', function(e) { //监听下拉框
					let index = e.elem.selectedIndex - 1;
					index = index < 0 ? 0 : index;
					if(e.elem.name == 'province') {
						_this.province = index;
					} else if(e.elem.name == 'city') {
						_this.city = index;
					} else {
						_this.area = index;
					}
					setTimeout(function() {
						_this.formss.render('select');
					}, 10);
				});
			});
		},
		methods: {
			getData(order_num) {
				let _this = this;
				this.order_num = order_num;
				api.getOrderDetail({
					token: this.getCookie('token'),
					order_num: order_num,
					type: 3,
				}).then((res) => {
					console.log(res);
					if(res.code == 1) {
						_this.order_info = res.data.order_info;
						// this.order_info.time = this.getTimes(res.data.order_info.createtime + 21600);
						_this.express_id = res.data.express_id;
						_this.mesh_attr = res.data.mesh_attr;
						_this.craft_demand = res.data.craft_demand;
						_this.open_demand = res.data.open_demand;
						_this.other_make = res.data.other_make;
						_this.take_info = res.data.take_info;
						_this.statuss = res.data.order_info.status;
						_this.orderprogress1 = res.data.order_progress;
						_this.express_info = res.data.express_info ? res.data.express_info : '';
						_this.finish_time = _this.getTimes2(res.data.order_info.express_finish_time);
						_this.onHide();
						// console.log('其他制作要求和工程文件-数组',this.other_make);
					}
				})
				api.getOrderProgress({
					token: this.getCookie('token'),
					order_num: order_num,
					type: 3,
				}).then((res) => {
					console.log(res)
					_this.timeline = res.data;
					_this.orderProgress(res.data, _this.statuss);

					if(_this.timeline.f_rework_time) {
						_this.countTime(_this.timeline.f_rework_time);
					} else {
						_this.countTime(_this.timeline.f_get_order_time);
					}
				})
				api.getAddressList({
					token: this.getCookie('token')
				}).then((res) => {
					_this.siteslist = res.data
				})
				api.query_express({
					token: this.getCookie('token'),
					express_num: 'IBJI1572515023',
					type: 3
				}).then((res) => {

				})
			},
			back() {
				this.$router.replace({
					path: '/shopCar'
				})
			},
			timeFormat(param) {
				return param < 10 ? '0' + param : param;
			},
			countTime(yitime) {
				let _this = this;
				let interval = setInterval(() => {
					let newTime = new Date().getTime();
					let endTime = (yitime + 21600) * 1000;
					let leftTime = endTime - newTime;
					let obj = null;
					if(leftTime >= 0) {
						let hour = Math.floor((leftTime / 1000 / 60 / 60) % 24);
						let min = Math.floor((leftTime / 1000 / 60) % 60);
						let sec = Math.floor((leftTime / 1000) % 60);
						obj = {
							hour: _this.timeFormat(hour),
							min: _this.timeFormat(min),
							sec: _this.timeFormat(sec)
						};
						_this.times = obj.hour + ':' + obj.min + ':' + obj.sec;
					} else {
						_this.times = '订单超时';
						clearInterval(interval);
					}
				}, 1000);
			},
			orderProgress(progress, status) {
				let _this = this;
				let obj = [];
				if(progress.createtime) {
					obj.push({
						title: '下单',
						time: progress.createtime,
						time_txt: this.getTimes(progress.createtime)
					})
				};
				if(progress.e_get_order_time) {
					obj.push({
						title: '工程师接单',
						time: progress.e_get_order_time,
						time_txt: this.getTimes(progress.e_get_order_time)
					})
				};
				if(progress.e_finish_order_time) {
					obj.push({
						title: '工程师完工',
						time: progress.e_finish_order_time,
						time_txt: this.getTimes(progress.e_finish_order_time)
					})
				};
				if(progress.f_get_order_time) {
					obj.push({
						title: '工厂接单',
						time: progress.f_get_order_time,
						time_txt: this.getTimes(progress.f_get_order_time)
					})
				};
				if(progress.f_finish_order_time) {
					obj.push({
						title: '已发货',
						time: progress.f_finish_order_time,
						time_txt: this.getTimes(progress.f_finish_order_time)
					})
				};
				if(progress.f_rep_order_time) {
					obj.push({
						title: '补发',
						time: progress.f_rep_order_time,
						time_txt: this.getTimes(progress.f_rep_order_time)
					})
				};
				if(progress.c_post_sale_time) {
					obj.push({
						title: '客户发起售后',
						time: progress.c_post_sale_time,
						time_txt: this.getTimes(progress.c_post_sale_time)
					})
				};
				if(progress.e_rework_time) {
					obj.push({
						title: '工程师返工',
						time: progress.e_rework_time,
						time_txt: this.getTimes(progress.e_rework_time)
					})
				};
				if(progress.e_rework_finish_time) {
					obj.push({
						title: '工程师返工完成',
						time: progress.e_rework_finish_time,
						time_txt: this.getTimes(progress.e_rework_finish_time)
					})
				};
				if(progress.f_rework_time || _this.order_info.sales_status == 2) {
					obj.push({
						title: '工厂重新发货',
						time: progress.f_rework_finish_time ? progress.f_rework_finish_time : progress.f_rework_time,
						time_txt: this.getTimes(progress.f_rework_finish_time ? progress.f_rework_finish_time : progress.f_rework_time)
					})
				};
				if(progress.c_finish_order_time) {
					obj.push({
						title: '订单完成',
						time: progress.c_finish_order_time,
						time_txt: this.getTimes(progress.c_finish_order_time),
					})
				}
				this.order_progress = obj;
			},
			finishOrder(ordertype) {
				let _this = this
				if(_this.express_id.id == 1 || _this.express_id.id == 5) {
					_this.layers.open({ // 顺丰
						type: 1,
						title: '确认下单',
						content: $('#sflayer'),
						shade: 0,
						area: '500px',
						btn: '发货',
						success: function(layero, index) {
							$(':focus').blur();
							if(_this.siteslist != []) {
								_this.fname = _this.siteslist[0].name
								_this.fphone = _this.siteslist[0].mobile
								_this.fsite = _this.siteslist[0].province + _this.siteslist[0].city + _this.siteslist[0].area + _this.siteslist[0].address
							}
						},
						yes: function(index, layero) {
							if(_this.submitshow == true) {
								_this.submitshow = false;
								if(_this.siteslist != []) {
									let receiverlist = [{
										address: _this.siteslist[0].address
									}, {
										city: _this.siteslist[0].city
									}, {
										county: _this.siteslist[0].area
									}, {
										mobile: _this.siteslist[0].mobile
									}, {
										name: _this.siteslist[0].name
									}, {
										province: _this.siteslist[0].province
									}, {
										town: _this.siteslist[0].address
									}];
									if(_this.express_id.id == 1) {
										api.f_add_express({
											token: _this.getCookie('token'),
											receiver: _this.take_info.take_id,
											sender: receiverlist,
											order_num: _this.order_num,
											order_id: _this.order_info.order_id,
											add_order_type: ordertype,
											express_id: _this.express_id.id
										}).then((res) => {
											if(res.code == 1) {
												let order_num = _this.order_num;
												_this.getData(order_num);
												_this.formss.render();
												layer.msg(res.msg, {
													icon: 1,
													anim: 5
												})
											} else {
												layer.msg(res.msg, {
													icon: 2,
													anim: 6
												})
											}
											_this.submitshow = true;
											layer.closeAll();
											return false;
										})
									} else if(_this.express_id.id == 5) {
										api.jg_express({
											token: _this.getCookie('token'),
											receiver: _this.take_info.take_id,
											sender: receiverlist,
											order_num: _this.order_num,
											order_id: _this.order_info.order_id,
											add_order_type: ordertype,
											express_id: _this.express_id.id
										}).then((res) => {
											if(res.code == 1) {
												let order_num = _this.order_num;
												_this.getData(order_num);
												_this.formss.render();
												layer.msg(res.msg, {
													icon: 1,
													anim: 5
												})
											} else {
												layer.msg(res.msg, {
													icon: 2,
													anim: 6
												})
											}
											_this.submitshow = true;
											layer.closeAll();
											return false;
										})
									}

								} else {
									layer.msg('请添加地址', {
										icon: 2,
										anim: 6
									})
								}
							}

						}
					})
				} else if(_this.express_id.id == 3 || _this.express_id.id == 2 || _this.express_id.id == 11) {
					_this.layers.open({
						type: 1,
						title: '发货信息',
						content: $('#express'),
						shade: 0,
						area: ['500px', '700px'],
						btn: '提交',
						success: function(layero, index) { // 成功弹出后回调
							// 解决按enter键重复弹窗问题
							$(':focus').blur();
							// 添加form标识
							layero.addClass('layui-form');
							// 将保存按钮改变成提交按钮
							layero.find('.layui-layer-btn0').attr({
								'lay-filter': 'addRole',
								'lay-submit': ''
							});
							console.log(_this.formss)
							if(_this.siteslist != []) {
								_this.fname = _this.siteslist[0].name
								_this.fphone = _this.siteslist[0].mobile
								_this.fsite = _this.siteslist[0].province + _this.siteslist[0].city + _this.siteslist[0].area + _this.siteslist[
									0].address
							}
							_this.formss.render();
							_this.formss.render('select');
						},
						yes: function(index, layero) {
							if(_this.submitshow == true) {
								_this.submitshow == false;
								if(_this.siteslist != []) {
									_this.formss.on('submit(addRole)', function(data) {
										let city2list = ['纸', '纤', '木箱', '木架', '托膜', '托木'];
										for(let i = 0; i < city2list.length; i++) {
											if(data.field.packing == i) {
												data.field.packing = city2list[i]
											}
										}
										let receiverlist = [{
											address: _this.siteslist[0].address
										}, {
											city: _this.siteslist[0].city
										}, {
											county: _this.siteslist[0].area
										}, {
											mobile: _this.siteslist[0].mobile
										}, {
											name: _this.siteslist[0].name
										}, {
											province: _this.siteslist[0].province
										}, {
											town: _this.siteslist[0].address
										}, {
											remarks: data.field.desc
										}];
										console.log(_this.express_id.id)
										if(_this.express_id.id == 3) {
											console.log(3)
											// 信丰
											api.xf_express({
												token: _this.getCookie('token'),
												cargoName: data.field.Hname,
												receiver: _this.take_info.take_id,
												sender: receiverlist,
												// deliveryType: data.field.mode + 1,
												totalNumber: data.field.title,
												// totalVolume: data.field.title2,
												totalWeight: data.field.title3,
												// packageService: data.field.packing,
												order_num: _this.order_num,
												order_id: _this.order_info.order_id,
												add_order_type: ordertype,
												express_id: _this.express_id.id,
												goodsNumber: data.field.title4
											}).then((res) => {
												if(res.code == 1) {
													let order_num = _this.order_num;
													_this.getData(order_num);
													_this.formss.render();
													layer.msg(res.msg, {
														icon: 1,
														anim: 5
													})
												} else {
													layer.msg(res.msg, {
														icon: 2,
														anim: 6
													})
												}
												_this.submitshow = true;
												layer.closeAll();
												return false;
											})
										} else if(_this.express_id.id == 2) {
											// 德邦
											api.max_add_express({
												token: _this.getCookie('token'),
												cargoName: data.field.Hname,
												receiver: _this.take_info.take_id,
												sender: receiverlist,
												deliveryType: data.field.mode + 1,
												totalNumber: data.field.title,
												totalVolume: data.field.title2,
												totalWeight: data.field.title3,
												packageService: data.field.packing,
												order_num: _this.order_num,
												order_id: _this.order_info.order_id,
												add_order_type: ordertype,
												express_id: _this.express_id.id
											}).then((res) => {
												if(res.code == 1) {
													let order_num = _this.order_num;
													_this.getData(order_num);
													_this.formss.render();
													layer.msg(res.msg, {
														icon: 1,
														anim: 5
													})
												} else {
													layer.msg(res.msg, {
														icon: 2,
														anim: 6
													})
												}
												_this.submitshow = true;
												layer.closeAll();
												return false;
											})
										} else if(_this.express_id.id == 11) {
											// 京东
											receiverlist.splice(6, 1);
											receiverlist[6].remark = _this.siteslist[0].address;
											if(data.field.title < 1000) {
												if(data.field.title2 < 10000) {
													if(data.field.title3 < 10000) {
														api.jd_express({
															token: _this.getCookie('token'),
															// cargoName: data.field.Hname,
															receiver: _this.take_info.take_id,
															sender: receiverlist,
															// deliveryType: data.field.mode + 1, 
															totalNumber: data.field.title,
															totalVolume: data.field.title2,
															totalWeight: data.field.title3,
															// packageService: data.field.packing,
															order_num: _this.order_num,
															order_id: _this.order_info.order_id,
															add_order_type: ordertype,
															express_id: _this.express_id.id
														}).then((res) => {
															if(res.code == 1) {
																let order_num = _this.order_num;
																_this.getData(order_num);
																_this.formss.render();
																layer.msg(res.msg, {
																	icon: 1,
																	anim: 5
																})
															} else {
																layer.msg(res.msg, {
																	icon: 2,
																	anim: 6
																})
															}
															_this.submitshow = true;
															layer.closeAll();
															return false;
														})
													} else {
														layer.msg('总重量超出范围(1-9999)kg', {
															icon: 2,
															anim: 6
														})
													}
												} else {
													layer.msg('总体积超出范围(1-9999)cm³', {
														icon: 2,
														anim: 6
													})
												}
											} else {
												layer.msg('总件数超出范围(1-999)件', {
													icon: 2,
													anim: 6
												})
											}
										}
									});
								} else {
									layer.msg('请添加地址', {
										icon: 2,
										anim: 6
									})
								}
							}

						}
					})
				} else if(_this.express_id.id == 12 || _this.express_id.id == 13) {
					_this.layers.open({
						title: '提示',
						content: '是否确认出货',
						btn: ['确定', '取消'],
						closeBtn: 0,
						btnAlign: 'c',
						resize: false,
						skin: 'demo-class',
						yes: function(index, layero) {
							if(_this.express_id.id == 12) {
								api.selfraising({
									token: _this.getCookie('token'),
									order_num: _this.order_num
								}).then((res) => {
									if(res.code == 1) {
										_this.getData(_this.order_num);
										layer.closeAll();
									} else {
										layer.msg(res.msg, {
											icon: 2,
											anim: 6
										})
									}
								})
							} else if(_this.express_id.id == 13) {
								api.selfdistribution({
									token: _this.getCookie('token'),
									order_num: _this.order_num
								}).then((res) => {
									if(res.code == 1) {
										_this.getData(_this.order_num);
										layer.closeAll();
									} else {
										layer.msg(res.msg, {
											icon: 2,
											anim: 6
										})
									}
								})
							}
						},
						btn2: function(index, layero) {
							layer.closeAll();
						}
					});
				}
			},
			fAppealOrder() { // 工厂售后材料不足申请
				let _this = this;
				this.layers.open({
					type: 1,
					title: '工厂申请信息',
					content: $('#applyer'),
					shade: 0,
					area: '500px',
					btn: '提交',
					yes: function(index, layero) {
						api.fAppealOrder({
							token: _this.getCookie('token'),
							order_num: _this.order_num,
							appeal_reason: _this.applyerText
						}).then((res) => {
							if(res.code == 1) {} else {
								layer.closeAll();
								layer.msg(res.msg, {
									icon: 2,
									anim: 6
								})
							}
						})
					}
				})
			},
			// 选择地址
			selectsite() {
				let _this = this;
				_this.layers.open({
					type: 1,
					title: '选择地址',
					content: $('#siteslists'),
					shade: 0,
					area: '500px',
					btn: '保存',
				})
			},
			select(item, i) {
				this.siteslist.splice(i, 1);
				this.siteslist.unshift(item);
				this.fname = this.siteslist[0].name;
				this.fphone = this.siteslist[0].mobile;
				this.fsite = this.siteslist[0].province + this.siteslist[0].city + this.siteslist[0].area + this.siteslist[0].address;
			},
			onLayer() {
				layer.open({
					title: '发货说明',
					content: '<div>1.请确认本订单内多个钢网是否全部生产完毕可全部统一发货</div></p><div>2.如果漏发需及时补发，补发的运费需要自主承担</div>',
					shade: 0,
					anim: 5,
					closeBtn: 0
				});
			},
			// 查询物流信息
			onLogistics(i) {
				let _this = this;
				if(_this.onLogisticsclick == true) {
					_this.onLogisticsclick = false;
					let name;
					let num;
					if(i == 1) {
						name = this.express_info.express_name;
						num = this.express_info.express_mailno;
						console.log(num)
						console.log(name)
					} else if(i == 2) {
						name = this.express_info.rep_express_name;
						num = this.express_info.rep_express_mailno;
					} else {
						name = this.express_info.sale_express_name;
						num = this.express_info.sale_express_mailno;
					}
					if(name == '顺丰速运') {
						api.shunfeng({
							express_num: num,
						}).then((res) => {
							if(res.code == 1) {
								let arr = res.data.Body.RouteResponse.Routes.attributes;
								let wuliu = [];
								arr.forEach((val, index) => {
									let obj = {
										description: val.remark,
										time: val.accept_time,
										site: val.accept_address
									}
									wuliu.push(obj);
								})
								_this.wuliu = wuliu;
								_this.wuliushow = true;
								_this.onLogisticsclick = true;
							} else {
								_this.onLogisticsclick = true;
								layer.msg(res.msg, {
									icon: 2,
									anim: 6
								})
							}
						})
					} else if(name == '德邦快递') {
						api.debang({
							mailNo: num
						}).then((res) => {
							if(res.code == 1) {
								res.data = JSON.parse(res.data);
								_this.wuliu = res.data.responseParam.trace_list;
								_this.wuliushow = true;
								_this.onLogisticsclick = true;
							} else {
								_this.onLogisticsclick = true;
								layer.msg(res.msg, {
									icon: 2,
									anim: 6
								})
							}
						})
					} else if(name == '京广速递') {
						api.jg_query({
							mailNo: num
						}).then((res) => {
							console.log(res)
							// res = JSON.parse(res);
							// datas = JSON.parse(res.data)
							if(res.code == 1) {
								_this.onLogisticsclick = true
								if(res.data.data.length == 0) {
									layer.msg('请等待揽件', {
										icon: 2,
										anim: 6
									})
								} else {
									let datas = res.data.data[1].data;
									let wuliu = [];
									datas.forEach((val, index) => {
										let obj = {
											description: val.scanType + ' ' + val.scanMan + val.scanSite,
											time: val.scanDate,
											site: val.content
										}
										wuliu.push(obj);
									})
									_this.wuliu = wuliu;
									_this.wuliushow = true;
									_this.onLogisticsclick = true;
								}
							} else {
								_this.onLogisticsclick = true;
								layer.msg(res.msg, {
									icon: 2,
									anim: 6
								})
							}
						})
					} else if(name == '信丰物流') {
						if(num) {
							api.xf_query({
								mailNo: num
							}).then((res) => {
								if(res.code == 1) {
									let datas = JSON.parse(res.data);
									let arr = datas.tracesList[0].traces;
									arr = arr.reverse();
									console.log(arr);
									let wuliu = [];
									console.log(datas);
									arr.forEach((val, index) => {
										let obj = {
											description: val.city,
											time: val.time,
											site: val.desc
										}
										wuliu.push(obj);
									})
									_this.wuliu = wuliu;
									_this.wuliushow = true;
									_this.onLogisticsclick = true;
								} else {
									_this.onLogisticsclick = true;
									layer.msg(res.msg, {
										icon: 2,
										anim: 6
									})
								}

							})
						} else {
							_this.onLogisticsclick = true;
							layer.msg('下单成功，等待快递员上门揽收，提供快递运单号', {
								icon: 1,
								anim: 6
							})
						}
					} else if(name == '京东快递') {
						api.jd_query({
							mailNo: num
						}).then((res) => {
							console.log(res)
							if(res.code == 1) {
								let arr = res.data.jingdong_ldop_receive_trace_get_responce.querytrace_result.data;
								if(arr == []) {
									layer.msg('请等待揽件', {
										icon: 2,
										anim: 6
									})
								} else {
									arr = arr.reverse();
									let wuliu = [];
									arr.forEach((val, index) => {
										let obj = {
											description: val.opeRemark,
											time: val.opeTime,
											site: val.opeTitle
										}
										wuliu.push(obj);
									})
									_this.wuliu = wuliu;
									_this.wuliushow = true;
									_this.onLogisticsclick = true;
								}
							} else {
								_this.onLogisticsclick = true;
								layer.msg(res.msg, {
									icon: 2,
									anim: 6
								})
							}
						})
					}
				}

			},
			onHide() {
				if(this.open_demand.length == 1 && this.open_demand[0].mesh_type == 2) {
					this.hideICBGAPAD = false;
				} else if(this.open_demand.length > 1) {
					let hide = false;
					for(let i = 0; i < this.open_demand.length; i++) {
						if(this.open_demand[i].mesh_type == 1) {
							hide = true;
						}
					}
					this.hideICBGAPAD = hide;
				}
			},
			// 跳转地址管理
			addsites() {
				layer.msg('请去添加地址', {
					icon: 2,
					anim: 6
				})
			},
			setClass(e) {
				this.showClass = e;
				// this.elements.render();
				if(e == 2) {

				}
			},
		},
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.progress ul li:last-child {
		padding-bottom: 0 !important;
	}
	
	.goutong {
		padding: 4px 8px;
		border: 1px solid;
		border-radius: 15px;
		margin-top: -5px;
	}
	
	.btn1 {
		background: rgb(139, 195, 74);
		border-radius: 15px;
		margin-top: -5px;
		cursor: pointer;
		padding: 0 15px;
		height: 30px;
		line-height: 30px;
		color: #fff;
		text-align: center;
		margin-left: 15px;
	}
	
	.btn2 {
		background: rgb(255, 152, 0);
		border-radius: 15px;
		margin-top: -5px;
		cursor: pointer;
		padding: 0 15px;
		height: 30px;
		line-height: 30px;
		color: #fff;
		text-align: center;
		margin-left: 15px;
	}
	
	.status p span {
		margin-left: 10px;
	}
	
	.shopCar {
		font-family: SourceHanSansSC;
	}
	
	.sxBox {
		padding: 20px 10% 10px;
	}
	
	.scektsBox {
		position: absolute;
		bottom: 0;
		right: 0;
		width: 100%;
	}
	
	.sitetext {
		overflow: hidden;
		text-overflow: ellipsis;
		width: 300px;
	}
	
	.title {
		padding: 8px 30px;
		color: #fff;
		border-radius: 5px;
	}
	
	.addsites {
		background: rgb(139, 195, 74);
		color: #fff;
		display: inline-block;
		text-align: center;
		line-height: 36px;
		border-radius: 10px;
		padding: 5px 30px;
	}
	
	.colorred {
		color: red;
	}
	
	.downloadBtn {
		width: 46px;
		height: 26px;
		line-height: 26px;
		font-size: 12px;
		background: #4876FF;
		color: #FFFFFF;
		display: inline-block;
		text-align: center;
		border-radius: 3px;
		margin-left: 5px;
	}
</style>


// WEBPACK FOOTER //
// src/components/orderDetail.vue